module.exports = __webpack_public_path__ + "img/individual_associated-person.7fbfff32.svg";